import React from 'react';
import Select from 'react-select';
import { useSelector, useDispatch } from "react-redux";
import { setSelectedAuthority } from "../actions/searchAction";

//Ref: https://react-select.com/props

const options = [
  { value: 'AZ', label: 'AZ' }, 
  { value: 'DC', label: 'DC' },
  { value: 'LA', label: 'LA' },
  { value: 'MD', label: 'MD' },
  { value: 'MS', label: 'MS' },
  { value: 'ND', label: 'ND' },
  { value: 'WA', label: 'WA' },
  { value: 'WV', label: 'WV' },
]

export const StateCombobox = (props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
 
  return (
    <div>
      <Select
        options={options}
        styles={{
          // Fixes the overlapping problem of the component
          menu: provided => ({ ...provided, zIndex: 9999 })
        }}
        name="stateSelect"
        defaultValue={{ label: state.searchModel.authorityName, value: state.searchModel.authorityName }}
        onChange={(newValue, actionMeta) => dispatch(setSelectedAuthority(newValue.value))} />
    </div>
  );
}

